module.exports = __webpack_public_path__ + "img/pp.c0cf7248.png";